import { render, staticRenderFns } from "./threeSystem.vue?vue&type=template&id=6474276c&scoped=true&"
import script from "./threeSystem.vue?vue&type=script&lang=js&"
export * from "./threeSystem.vue?vue&type=script&lang=js&"
import style0 from "./threeSystem.vue?vue&type=style&index=0&id=6474276c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474276c",
  null
  
)

export default component.exports